// saloni-upsell-free-gift-metaobject
const FREE_GIFT_DEBUG = false;

const FREE_GIFT_CAMPAIGNS = Array.isArray(window.PG_FREE_GIFT_CAMPAIGNS)
  ? window.PG_FREE_GIFT_CAMPAIGNS
  : [];

// Restore persisted coupon state across page loads so the gift isn't removed when
// the "Every Discount Possible" app temporarily makes the code non-applicable while
// the free gift's own discount is in the cart (non-combinable conflict).
if (!Array.isArray(window.PG_APPLIED_COUPON_CODES)) {
  try {
    var _pgStored = sessionStorage.getItem('pg_applied_coupon_codes');
    if (_pgStored) {
      window.PG_APPLIED_COUPON_CODES = JSON.parse(_pgStored);
    }
  } catch(e) {}
}
const CART_UPDATE_DEBOUNCE_MS = 180;
const COLLECTION_RULE_RETRY_DELAY_MS = 300;
const CHECKOUT_SYNC_TIMEOUT_MS = 2000;
let isGiftMutationInFlight = false;
let shouldRecheckAfterMutation = false;
let collectionRuleRetryTimer = null;
let cartUpdateDebounceTimer = null;
let pendingScheduledCart = null;
let latestKnownCart = null;
let currentGiftProcessingPromise = Promise.resolve();
let isGiftProcessing = false;
let isCartUpdateInFlight = false;
let cartUpdateCompletionPromise = Promise.resolve();
let resolveCartUpdateCompletion = null;

if (FREE_GIFT_DEBUG) {
  console.log("[FREE GIFT] Campaign config count:", FREE_GIFT_CAMPAIGNS.length);
  console.log("[FREE GIFT] Campaign config payload:", FREE_GIFT_CAMPAIGNS);
}

if (sessionStorage.getItem("pg_free_gift_cleaned")) {
  sessionStorage.removeItem("pg_free_gift_cleaned");
}

function postCartForm(url, data) {
  return fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    body: new URLSearchParams(data).toString()
  }).then(function(response) {
    if (response.ok) {
      return response.json();
    }

    return response.json().catch(function() {
      return {};
    }).then(function(errorPayload) {
      return Promise.reject(errorPayload);
    });
  });
}

function postCartJson(url, data) {
  return fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }).then(function(response) {
    if (response.ok) {
      return response.json();
    }

    return response.json().catch(function() {
      return {};
    }).then(function(errorPayload) {
      return Promise.reject(errorPayload);
    });
  });
}

function addProductsToCart(variantIdsArr) {
  if (!variantIdsArr.length) {
    return Promise.resolve();
  }

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Add variants:", variantIdsArr);
  }
  return postCartJson("/cart/add.js", {
    items: variantIdsArr.map(function(variantId) {
      return {
        id: variantId,
        quantity: 1,
        properties: {
          _is_free_gift: "true"
        }
      };
    })
  }).then(function(response) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Success adding variants:", variantIdsArr);
    }
    return response;
  }).catch(function(error) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Error adding variants:", variantIdsArr, error);
    }
    throw error;
  });
}

function removeProductsFromCart(lineKeysArr) {
  if (!lineKeysArr.length) {
    return Promise.resolve();
  }

  const updates = {};
  $.map(lineKeysArr, function(lineKey) {
    updates["updates[" + lineKey + "]"] = 0;
  });

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Remove line keys:", lineKeysArr);
  }
  return postCartForm("/cart/update.js", updates).catch(function(error) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Error removing line keys:", lineKeysArr, error);
    }
    throw error;
  });
}

let giftScriptRefreshCount = 0;

function refreshCartDrawer() {
  giftScriptRefreshCount++;
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true
    })
  );
}

function trackGiftProcessing(promise) {
  isGiftProcessing = true;
  currentGiftProcessingPromise = Promise.resolve(promise)
    .catch(function(error) {
      if (FREE_GIFT_DEBUG) {
        console.log("[FREE GIFT] Processing error:", error);
      }
    })
    .finally(function() {
      isGiftProcessing = false;
    });

  return currentGiftProcessingPromise;
}

function fetchCart() {
  return fetch("/cart.js", {
    credentials: "same-origin"
  }).then(function(response) {
    return response.json();
  });
}

function getCartVariantIds(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return [];
  }

  return $.map(cart.items, function(item) {
    return String(item.variant_id || item.id || "").trim();
  }).filter(Boolean);
}

function getCartLineKeysByVariantIds(cart, variantIdsArr) {
  if (!cart || !Array.isArray(cart.items) || !variantIdsArr.length) {
    return [];
  }

  const targetVariantIds = new Set($.map(variantIdsArr, function(variantId) {
    return String(variantId);
  }));

  return $.map(cart.items, function(item) {
    const itemVariantId = String(item.variant_id || item.id || "").trim();
    if (!itemVariantId || !targetVariantIds.has(itemVariantId) || !item.key) {
      return null;
    }

    return String(item.key);
  }).filter(Boolean);
}

async function processGiftQueue(addVariantIdsArr, removeVariantIdsArr) {
  if (!addVariantIdsArr.length && !removeVariantIdsArr.length) {
    return;
  }

  isGiftMutationInFlight = true;
  let didRunMutations = false;

  try {
    const latestCart = await fetchCart().catch(function() {
      return null;
    });
    const liveCartVariantSet = new Set(getCartVariantIds(latestCart));
    const safeRemoveVariantIdsArr = removeVariantIdsArr.filter(function(variantId) {
      return liveCartVariantSet.has(String(variantId));
    });
    const safeAddVariantIdsArr = addVariantIdsArr.filter(function(variantId) {
      return !liveCartVariantSet.has(String(variantId));
    });
    const safeRemoveLineKeysArr = getCartLineKeysByVariantIds(latestCart, safeRemoveVariantIdsArr);
    const hasLiveMutations = safeRemoveLineKeysArr.length > 0 || safeAddVariantIdsArr.length > 0;

    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Queue after live cart check:", {
        liveCartVariantIds: Array.from(liveCartVariantSet),
        safeAddVariantIdsArr: safeAddVariantIdsArr,
        safeRemoveVariantIdsArr: safeRemoveVariantIdsArr,
        safeRemoveLineKeysArr: safeRemoveLineKeysArr,
        hasLiveMutations: hasLiveMutations
      });
    }

    if (!hasLiveMutations) {
      return;
    }

    didRunMutations = true;

    try {
      await removeProductsFromCart(safeRemoveLineKeysArr);
    } catch (error) {
      console.log("[FREE GIFT] Skipping failed bulk remove:", safeRemoveLineKeysArr, error);
    }

    try {
      await addProductsToCart(safeAddVariantIdsArr);
    } catch (error) {
      console.log("[FREE GIFT] Skipping failed bulk add:", safeAddVariantIdsArr, error);
    }
  } finally {
    isGiftMutationInFlight = false;

    if (didRunMutations) {
      refreshCartDrawer();
    }

    if (shouldRecheckAfterMutation) {
      shouldRecheckAfterMutation = false;
      const latestCart = await fetchCart();
      await checkCart(latestCart);
    }
  }
}

function filterAddRemoveItems(addVariantIds, removeVariantIds, cartItemsArr) {
  const cartItemSet = new Set(cartItemsArr);
  const removeVariantSet = new Set(
    $.unique(removeVariantIds).filter(function(v) {
      return v !== "";
    })
  );
  const addVariantSet = new Set(
    $.unique(addVariantIds).filter(function(v) {
      return v !== "";
    })
  );

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] filterAddRemoveItems input:", {
      addVariantIdsArr: Array.from(addVariantSet),
      removeVariantIdsArr: Array.from(removeVariantSet),
      cartItemsArr: cartItemsArr
    });
  }

  addVariantSet.forEach(function(value) {
    if (removeVariantSet.has(value)) {
      removeVariantSet.delete(value);

      if (cartItemSet.has(value)) {
        addVariantSet.delete(value);
      }
    }
  });

  addVariantSet.forEach(function(variantId) {
    if (cartItemSet.has(variantId)) {
      addVariantSet.delete(variantId);
    }
  });

  removeVariantSet.forEach(function(variantId) {
    if (!cartItemSet.has(variantId)) {
      removeVariantSet.delete(variantId);
    }
  });

  const addVariantIdsArr = Array.from(addVariantSet);
  const removeVariantIdsArr = Array.from(removeVariantSet);

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] filterAddRemoveItems output:", {
      addVariantIdsArr: addVariantIdsArr,
      removeVariantIdsArr: removeVariantIdsArr
    });
  }

  return processGiftQueue(addVariantIdsArr, removeVariantIdsArr);
}

function normalizeType(type) {
  return String(type || "")
    .trim()
    .replace(/[\s-]+/g, "_")
    .toUpperCase();
}

function normalizePlatform(platform) {
  return String(platform || "")
    .trim()
    .toLowerCase();
}

function isTruthy(value) {
  if (value === true || value === false) {
    return value;
  }

  if (value === 1 || value === "1") {
    return true;
  }

  if (value === 0 || value === "0") {
    return false;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "yes";
  }

  if (value && typeof value === "object" && "value" in value) {
    return isTruthy(value.value);
  }

  return !!value;
}

function isFreeGiftCartItem(item) {
  if (!item) {
    return false;
  }

  const properties = item.properties || {};
  return (
    properties._is_free_gift === "true" ||
    properties._free_product === "true"
  );
}

function getAppliedCouponCodesFromDom() {
  var codes = [];
  document.querySelectorAll(".discount_lable_remove .btn-txt").forEach(function(el) {
    var code = (el.textContent || "").trim().toUpperCase();
    if (code) codes.push(code);
  });
  return codes;
}

// Automatic (non-code) discounts never appear in cart.discount_codes; they show as
// discount APPLICATIONS identified by title (cart-level + line-level). Collect those
// titles so a rule keyed to an automatic discount (e.g. an automatic B1G1) can match.
function getAppliedDiscountTitles(cart) {
  var titles = [];
  if (!cart) {
    return titles;
  }

  (cart.cart_level_discount_applications || []).forEach(function(d) {
    if (d && d.title) {
      titles.push(String(d.title).trim().toUpperCase());
    }
  });

  (cart.items || []).forEach(function(item) {
    (item.discounts || []).forEach(function(d) {
      if (d && d.title) {
        titles.push(String(d.title).trim().toUpperCase());
      }
    });
    (item.line_level_discount_allocations || []).forEach(function(a) {
      var t = a && a.discount_application && a.discount_application.title;
      if (t) {
        titles.push(String(t).trim().toUpperCase());
      }
    });
  });

  return titles;
}

function getCouponCodeForRule(rule) {
  var code = String(rule.couponCode || "").trim();
  if (!code && normalizeType(rule.type) === "COUPON") {
    code = String(rule.title || "").trim();
  }
  return code.toUpperCase();
}

function _persistCouponCodes(codes) {
  window.PG_APPLIED_COUPON_CODES = codes;
  try { sessionStorage.setItem('pg_applied_coupon_codes', JSON.stringify(codes)); } catch(e) {}
}

function hasRequiredCoupon(rule, cart) {
  var required = getCouponCodeForRule(rule);
  if (!required) return true;

  // Automatic discounts aren't codes — match them by the applied discount title.
  if (cart && getAppliedDiscountTitles(cart).indexOf(required) !== -1) {
    return true;
  }

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Coupon check:", {
      required: required,
      pgApplied: window.PG_APPLIED_COUPON_CODES,
      domCodes: getAppliedCouponCodesFromDom(),
      cartCodes: cart && cart.discount_codes
    });
  }

  // Primary: the persisted/staged code cache. It's kept honest by (a) a load-time
  // reconcile against /cart.js (so a code removed at checkout is cleared — see
  // $(document).ready below) and (b) applyDiscountCode staging a code mid-apply
  // before /cart.js reflects it. We can't read /cart.js first here: during apply
  // it lags behind the storefront cart, so the gift would never land.
  if (Array.isArray(window.PG_APPLIED_COUPON_CODES)) {
    return window.PG_APPLIED_COUPON_CODES.indexOf(required) !== -1;
  }

  // DOM chip fallback — when found, promote so future checks stay stable.
  var domCodes = getAppliedCouponCodesFromDom();
  if (domCodes.length > 0) {
    _persistCouponCodes(domCodes);
    return domCodes.indexOf(required) !== -1;
  }

  // /cart.js discount_codes fallback.
  if (!cart || !Array.isArray(cart.discount_codes)) return false;
  var cartCodes = cart.discount_codes
    .map(function(dc) { return String(dc.code || "").trim().toUpperCase(); })
    .filter(Boolean);
  var found = cartCodes.indexOf(required) !== -1;
  if (found) {
    _persistCouponCodes(cartCodes);
  }
  return found;
}

function isRuleForCurrentPlatform(rulePlatform) {
  const platform = normalizePlatform(rulePlatform);
  return (
    platform === "" ||
    platform === "both" ||
    platform === "website"
  );
}

function isCampaignEligible(campaign) {
  if (!campaign || !isTruthy(campaign.enabled)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Campaign blocked (disabled):", campaign);
    }
    return false;
  }

  if (!isRuleForCurrentPlatform(campaign.platform)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Campaign blocked (platform mismatch):", campaign.title, campaign.platform);
    }
    return false;
  }

  return true;
}

function getRuleProgress(rule, cartTotal, cartItemsCount, cart, variantCollectionMap) {
  if (!rule || !isTruthy(rule.enabled) || !rule.giftVariantId) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule blocked (missing enabled/giftVariantId):", rule);
    }
    return null;
  }

  if (!isRuleForCurrentPlatform(rule.platform)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule blocked (platform mismatch):", rule.title, rule.platform);
    }
    return null;
  }

  if (!hasRequiredCoupon(rule, cart)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule blocked (required coupon not applied):", rule.title, rule.couponCode);
    }
    return null;
  }

  const type = normalizeType(rule.type);
  const minAmount = Number(rule.minimumAmount || 0);
  const minCount = Number(rule.minimumProductCount || 0);
  let currentValue = 0;
  let requiredValue = 0;
  let unit = "amount";

  if (type === "BUY_X_PRODUCT_FROM_COLLECTION_Y") {
    const stats = getCollectionStats(rule, cart, variantCollectionMap);
    currentValue = stats.count;
    requiredValue = minCount;
    unit = "item";
  } else if (type === "SPENDING_X_AMOUNT_IN_COLLECTION_Y") {
    const stats = getCollectionStats(rule, cart, variantCollectionMap);
    currentValue = stats.amount;
    requiredValue = minAmount;
  } else if (type === "SPENDING_X_AMOUNT") {
    currentValue = cartTotal;
    requiredValue = minAmount;
  } else if (type === "COUPON") {
    if (minCount > 0) {
      currentValue = getRuleProductCount(rule, cart, variantCollectionMap, cartItemsCount);
      requiredValue = minCount;
      unit = "item";
    } else {
      return {
        eligible: true,
        showable: false,
        rule: rule
      };
    }
  } else if (minAmount > 0) {
    currentValue = cartTotal;
    requiredValue = minAmount;
  } else if (minCount > 0) {
    currentValue = cartItemsCount;
    requiredValue = minCount;
    unit = "item";
  }

  if (requiredValue <= 0) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule blocked (no usable threshold):", rule.title, { type: type, minAmount: minAmount, minCount: minCount });
    }
    return null;
  }

  const eligible = currentValue >= requiredValue;
  const progress = {
    eligible: eligible,
    showable: true,
    currentValue: currentValue,
    requiredValue: requiredValue,
    remaining: Math.max(0, requiredValue - currentValue),
    progressRatio: Math.min(1, currentValue / requiredValue),
    unit: unit,
    isCollectionScoped: normalizeHandleList(rule.collectionHandles).some(function(handle) {
      return handle !== "all" && handle !== "*";
    }),
    rule: rule
  };

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Rule progress:", rule.title, progress);
  }
  return progress;
}

function isRuleEligible(rule, cartTotal, cartItemsCount, cart, variantCollectionMap) {
  const progress = getRuleProgress(rule, cartTotal, cartItemsCount, cart, variantCollectionMap);
  return Boolean(progress && progress.eligible);
}

function normalizeHandleList(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return $.map(value, function(item) {
      return String(item || "").trim().toLowerCase();
    }).filter(Boolean);
  }

  return String(value)
    .split(",")
    .map(function(item) {
      return item.trim().toLowerCase();
    })
    .filter(Boolean);
}

function getVariantCollectionMapFromDom() {
  const collectionMap = {};
  const lineItems = document.querySelectorAll("cart-drawer line-item.line-item[data-line]");

  $.map(lineItems, function(lineItem) {
    const variantId = String(
      lineItem.getAttribute("data-variant-id") ||
      lineItem.getAttribute("data-line") ||
      ""
    ).trim();
    if (!variantId) {
      return;
    }

    const collectionValue =
      lineItem.getAttribute("data-product-collection") ||
      lineItem.getAttribute("data-product-colletion") ||
      "";

    collectionMap[variantId] = normalizeHandleList(collectionValue);
  });

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Variant to collections map:", collectionMap);
  }
  return collectionMap;
}

function getCollectionStats(rule, cart, variantCollectionMap) {
  var requiredHandles = normalizeHandleList(rule.collectionHandles);
  if (!requiredHandles.length) {
    return { amount: 0, count: 0 };
  }

  var matchAll = requiredHandles.indexOf("all") !== -1 || requiredHandles.indexOf("*") !== -1;
  var requiredSet = {};
  $.map(requiredHandles, function(handle) {
    requiredSet[handle] = true;
  });

  var amount = 0;
  var count = 0;

  $.map(cart.items, function(item) {
    var itemVariantId = String(item.variant_id || item.id || "").trim();
    var lineAmount = Number(item.original_line_price != null ? item.original_line_price : item.final_line_price || 0);

    if (isFreeGiftCartItem(item)) {
      return;
    }

    if (matchAll) {
      amount += lineAmount;
      count += item.quantity;
      return;
    }

    var itemCollections = variantCollectionMap[itemVariantId] || [];
    var belongs = false;
    $.map(itemCollections, function(handle) {
      if (requiredSet[handle]) {
        belongs = true;
      }
    });

    if (belongs) {
      amount += lineAmount;
      count += item.quantity;
    }
  });

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Collection stats:", rule.title, { amount: amount / 100, count: count, requiredHandles: requiredHandles });
  }
  return { amount: amount / 100, count: count };
}

// Product count to compare against a rule's minimumProductCount.
// When the rule scopes to collections, count only items in those collections.
// When it has no collections (e.g. a plain coupon gift), count all non-gift
// cart items — otherwise getCollectionStats returns 0 and the rule can never
// qualify even with the coupon applied.
function getRuleProductCount(rule, cart, variantCollectionMap, fallbackCount) {
  if (normalizeHandleList(rule.collectionHandles).length > 0) {
    return getCollectionStats(rule, cart, variantCollectionMap).count;
  }

  if (typeof fallbackCount === "number") {
    return fallbackCount;
  }

  var count = 0;
  $.map(cart.items, function(item) {
    if (!isFreeGiftCartItem(item)) {
      count += item.quantity;
    }
  });
  return count;
}

function matchesRuleCollections(rule, cart, variantCollectionMap) {
  const requiredCollectionHandles = normalizeHandleList(rule.collectionHandles);
  if (!requiredCollectionHandles.length) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule collection check skipped (no collections):", rule.title);
    }
    return true;
  }

  if (requiredCollectionHandles.indexOf("all") !== -1 || requiredCollectionHandles.indexOf("*") !== -1) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Rule collection wildcard matched:", rule.title, requiredCollectionHandles);
    }
    return true;
  }

  const requiredSet = {};
  $.map(requiredCollectionHandles, function(handle) {
    requiredSet[handle] = true;
  });

  let matched = false;
  $.map(cart.items, function(item) {
    if (matched) {
      return;
    }

    if (isFreeGiftCartItem(item)) {
      return;
    }

    const itemVariantId = String(item.variant_id || item.id || "").trim();
    const itemCollections = variantCollectionMap[itemVariantId] || [];
    $.map(itemCollections, function(handle) {
      if (requiredSet[handle]) {
        matched = true;
      }
    });
  });

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Rule collection check:", rule.title, {
      requiredCollectionHandles: requiredCollectionHandles,
      matched: matched
    });
  }
  return matched;
}

function getCampaignVariantsToAdd(campaign, cart, cartTotal, cartItemsCount, variantCollectionMap) {
  const matchingVariants = [];
  if (!isCampaignEligible(campaign) || !Array.isArray(campaign.rules)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Campaign blocked:", campaign);
    }
    return matchingVariants;
  }

  $.map(campaign.rules, function(rule) {
    const variantId = String(rule.giftVariantId || "").trim();
    if (!variantId) {
      return;
    }

    if (isRuleEligible(rule, cartTotal, cartItemsCount, cart, variantCollectionMap) && matchesRuleCollections(rule, cart, variantCollectionMap)) {
      matchingVariants.push(variantId);
    }
  });

  if (isTruthy(campaign.multipleFreeGiftAllowed)) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Campaign matched variants (multiple allowed):", campaign.title, matchingVariants);
    }
    return matchingVariants;
  }

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Campaign matched variants (single mode):", campaign.title, matchingVariants);
  }
  return matchingVariants.length > 0 ? [matchingVariants[0]] : [];
}

function getAllConfigVariantIds() {
  const allVariantIds = [];
  $.map(FREE_GIFT_CAMPAIGNS, function(campaign) {
    if (!campaign || !Array.isArray(campaign.rules)) {
      return;
    }

    $.map(campaign.rules, function(rule) {
      const variantId = String(rule.giftVariantId || "").trim();
      if (variantId) {
        allVariantIds.push(variantId);
      }
    });
  });

  return $.unique(allVariantIds);
}

const CONFIGURED_VARIANT_IDS = getAllConfigVariantIds();

function hasCollectionBasedRules() {
  let found = false;

  $.map(FREE_GIFT_CAMPAIGNS, function(campaign) {
    if (found || !campaign || !Array.isArray(campaign.rules)) {
      return;
    }

    $.map(campaign.rules, function(rule) {
      const type = normalizeType(rule && rule.type);
      if (
        type === "BUY_X_PRODUCT_FROM_COLLECTION_Y" ||
        type === "SPENDING_X_AMOUNT_IN_COLLECTION_Y" ||
        normalizeHandleList(rule && rule.collectionHandles).length > 0
      ) {
        found = true;
      }
    });
  });

  return found;
}

const HAS_COLLECTION_BASED_RULES = hasCollectionBasedRules();

function scheduleCheckCart(cart, delayMs) {
  if (!cart) {
    return;
  }

  latestKnownCart = cart;
  pendingScheduledCart = cart;

  if (cartUpdateDebounceTimer) {
    clearTimeout(cartUpdateDebounceTimer);
  }

  cartUpdateDebounceTimer = setTimeout(function() {
    cartUpdateDebounceTimer = null;
    const scheduledCart = pendingScheduledCart || cart;
    pendingScheduledCart = null;
    trackGiftProcessing(checkCart(scheduledCart));
  }, delayMs);
}

function evaluateGiftRules(cart) {
  const cartItemsArr = [];
  let freeGiftTotal = 0;
  let freeGiftCount = 0;

  $.map(cart.items, function(item) {
    const itemVariantId = String(item.variant_id || item.id || "").trim();
    if (itemVariantId) {
      cartItemsArr.push(itemVariantId);
    }

    if (isFreeGiftCartItem(item)) {
      freeGiftTotal += item.final_line_price;
      freeGiftCount += item.quantity;
    }
  });

  const uniqueCartItemVariantIds = $.unique(cartItemsArr);
  const cartTotal = (cart.total_price - freeGiftTotal) / 100;
  const cartItemsCount = cart.item_count - freeGiftCount;
  const variantCollectionMap = getVariantCollectionMapFromDom();
  const variantCollectionCount = Object.keys(variantCollectionMap).length;

  if (
    HAS_COLLECTION_BASED_RULES &&
    cartItemsCount > 0 &&
    variantCollectionCount < uniqueCartItemVariantIds.length
  ) {
    if (FREE_GIFT_DEBUG) {
      console.log("[FREE GIFT] Delaying collection-based evaluation until cart drawer DOM catches up:", {
        cartItemsCount: cartItemsCount,
        uniqueCartItemVariantIds: uniqueCartItemVariantIds,
        variantCollectionCount: variantCollectionCount
      });
    }

    if (collectionRuleRetryTimer) {
      clearTimeout(collectionRuleRetryTimer);
    }

    collectionRuleRetryTimer = setTimeout(function() {
      collectionRuleRetryTimer = null;
      scheduleCheckCart(cart, 0);
    }, COLLECTION_RULE_RETRY_DELAY_MS);

    return Promise.resolve();
  }

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Cart context:", {
      cartTotal: cartTotal,
      cartItemsCount: cartItemsCount,
      freeGiftTotal: freeGiftTotal,
      freeGiftCount: freeGiftCount,
      cartItems: cart.items
    });
  }

  let addVariantIds = [];
  $.map(FREE_GIFT_CAMPAIGNS, function(campaign) {
    addVariantIds = addVariantIds.concat(
      getCampaignVariantsToAdd(campaign, cart, cartTotal, cartItemsCount, variantCollectionMap)
    );
  });

  const eligibleVariantIds = $.unique(addVariantIds);
  const removeVariantIds = $.grep(CONFIGURED_VARIANT_IDS, function(variantId) {
    return $.inArray(variantId, eligibleVariantIds) === -1;
  });
  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] Final variants:", {
      eligibleVariantIds: eligibleVariantIds,
      configuredVariantIds: CONFIGURED_VARIANT_IDS,
      removeVariantIds: removeVariantIds
    });
  }
  return filterAddRemoveItems(eligibleVariantIds, removeVariantIds, uniqueCartItemVariantIds);
}

function checkCart(cart) {
  if (!cart || !Array.isArray(cart.items) || cart.item_count === 0) {
    return Promise.resolve();
  }

  latestKnownCart = cart;

  if (!FREE_GIFT_CAMPAIGNS.length) {
    return Promise.resolve();
  }

  if (isGiftMutationInFlight) {
    shouldRecheckAfterMutation = true;
    return Promise.resolve();
  }

  return evaluateGiftRules(cart);
}

function hasPendingGiftProcessing() {
  return Boolean(
    isCartUpdateInFlight ||
    isGiftProcessing ||
    isGiftMutationInFlight ||
    cartUpdateDebounceTimer ||
    collectionRuleRetryTimer
  );
}

function markCartUpdateStarted() {
  if (isCartUpdateInFlight) {
    return;
  }

  isCartUpdateInFlight = true;
  cartUpdateCompletionPromise = new Promise(function(resolve) {
    resolveCartUpdateCompletion = resolve;
  });
}

function markCartUpdateCompleted() {
  isCartUpdateInFlight = false;

  if (typeof resolveCartUpdateCompletion === "function") {
    resolveCartUpdateCompletion();
  }

  resolveCartUpdateCompletion = null;
  cartUpdateCompletionPromise = Promise.resolve();
}

function getCheckoutLoader(button) {
  if (!button) {
    return null;
  }

  let loader = button.querySelector(".pg-free-gift-checkout-loader");
  if (loader) {
    return loader;
  }

  loader = document.createElement("span");
  loader.className = "pg-free-gift-checkout-loader";
  loader.setAttribute("aria-hidden", "true");
  loader.innerHTML = '<div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div>';
  button.appendChild(loader);
  return loader;
}

function setCheckoutButtonsLoading(isLoading, activeButton) {
  const checkoutButton = activeButton || document.querySelector('#mini-cart .checkout-button[name="checkout"]');
  if (!checkoutButton) {
    return;
  }

  getCheckoutLoader(checkoutButton);

  if (isLoading) {
    checkoutButton.setAttribute(
      "data-free-gift-disabled-before",
      checkoutButton.disabled ? "true" : "false"
    );
    checkoutButton.setAttribute("data-free-gift-loading", "true");
    checkoutButton.disabled = true;
    return;
  }

  if (!checkoutButton.hasAttribute("data-free-gift-loading")) {
    return;
  }

  checkoutButton.removeAttribute("data-free-gift-loading");

  const wasDisabled = checkoutButton.getAttribute("data-free-gift-disabled-before") === "true";
  checkoutButton.removeAttribute("data-free-gift-disabled-before");
  checkoutButton.disabled = wasDisabled;
}

function waitForTimeout(timeoutMs) {
  return new Promise(function(resolve) {
    setTimeout(resolve, timeoutMs);
  });
}

async function flushPendingGiftProcessing() {
  if (!FREE_GIFT_CAMPAIGNS.length) {
    return;
  }

  if (isCartUpdateInFlight) {
    await cartUpdateCompletionPromise;
  }

  if (cartUpdateDebounceTimer) {
    clearTimeout(cartUpdateDebounceTimer);
    cartUpdateDebounceTimer = null;

    const scheduledCart = pendingScheduledCart || latestKnownCart;
    pendingScheduledCart = null;

    if (scheduledCart) {
      await trackGiftProcessing(checkCart(scheduledCart));
    }
  }

  if (collectionRuleRetryTimer) {
    clearTimeout(collectionRuleRetryTimer);
    collectionRuleRetryTimer = null;

    if (latestKnownCart) {
      await trackGiftProcessing(checkCart(latestKnownCart));
    }
  }

  await currentGiftProcessingPromise;

  if (isGiftMutationInFlight) {
    await currentGiftProcessingPromise;
  }

  if (hasPendingGiftProcessing() || !latestKnownCart) {
    const latestCart = await fetchCart().catch(function() {
      return null;
    });

    if (latestCart) {
      latestKnownCart = latestCart;
      await trackGiftProcessing(checkCart(latestCart));
    }
  }

  await currentGiftProcessingPromise;
}

async function guardCheckoutUntilGiftProcessingCompletes(button) {
  if (!hasPendingGiftProcessing()) {
    return;
  }

  setCheckoutButtonsLoading(true, button);

  try {
    await Promise.race([
      flushPendingGiftProcessing(),
      waitForTimeout(CHECKOUT_SYNC_TIMEOUT_MS)
    ]);
  } finally {
    setCheckoutButtonsLoading(false, button);
  }
}

function getCouponRuleInfo(couponCode) {
  var normalized = String(couponCode || "").trim().toUpperCase();
  if (!normalized) return { eligible: true, rule: null, requiredCount: 0, currentCount: 0 };
  var cart = latestKnownCart;
  if (!cart) return { eligible: true, rule: null, requiredCount: 0, currentCount: 0 };
  var variantCollectionMap = getVariantCollectionMapFromDom();
  for (var i = 0; i < FREE_GIFT_CAMPAIGNS.length; i++) {
    var campaign = FREE_GIFT_CAMPAIGNS[i];
    if (!isCampaignEligible(campaign) || !Array.isArray(campaign.rules)) continue;
    for (var j = 0; j < campaign.rules.length; j++) {
      var rule = campaign.rules[j];
      var ruleCoupon = getCouponCodeForRule(rule);
      if (ruleCoupon !== normalized) continue;
      var minCount = Number(rule.minimumProductCount || 0);
      var currentCount = getRuleProductCount(rule, cart, variantCollectionMap);
      return {
        eligible: minCount === 0 || currentCount >= minCount,
        rule: rule,
        requiredCount: minCount,
        currentCount: currentCount
      };
    }
  }
  return { eligible: true, rule: null, requiredCount: 0, currentCount: 0 };
}

function getExclusiveCoupons(couponCode) {
  var normalized = String(couponCode || "").trim().toUpperCase();
  var exclusiveCodes = [];
  for (var i = 0; i < FREE_GIFT_CAMPAIGNS.length; i++) {
    var campaign = FREE_GIFT_CAMPAIGNS[i];
    if (!Array.isArray(campaign.rules)) continue;
    var campaignCodes = [];
    var hasThisCode = false;
    for (var j = 0; j < campaign.rules.length; j++) {
      var code = getCouponCodeForRule(campaign.rules[j]);
      if (!code) continue;
      campaignCodes.push(code);
      if (code === normalized) hasThisCode = true;
    }
    if (hasThisCode) {
      campaignCodes.forEach(function(code) {
        if (code !== normalized) exclusiveCodes.push(code);
      });
    }
  }
  return exclusiveCodes;
}

window.PGFreeGiftSync = {
  waitForCheckoutReady: guardCheckoutUntilGiftProcessingCompletes,
  checkCouponEligibility: getCouponRuleInfo,
  getExclusiveCoupons: getExclusiveCoupons,
  reEvaluate: function() {
    trackGiftProcessing(
      fetchCart().then(function(cart) {
        if (cart) { latestKnownCart = cart; return checkCart(cart); }
      })
    );
  }
};

document.addEventListener("line-item-quantity:change:start", function() {
  markCartUpdateStarted();
}, true);

document.addEventListener("line-item-quantity:change:end", function(event) {
  markCartUpdateCompleted();

  if (event.detail && event.detail.cart) {
    latestKnownCart = event.detail.cart;
    trackGiftProcessing(checkCart(event.detail.cart));
  }
}, true);

document.addEventListener("cart:updated", function(event) {
  const cart = event.detail.cart;
  markCartUpdateCompleted();
  scheduleCheckCart(cart, CART_UPDATE_DEBOUNCE_MS);
});

document.documentElement.addEventListener("cart:refresh", function() {
  if (giftScriptRefreshCount > 0) {
    giftScriptRefreshCount--;
    return;
  }

  if (FREE_GIFT_DEBUG) {
    console.log("[FREE GIFT] External cart:refresh detected (e.g. discount change), re-evaluating");
  }

  setTimeout(function() {
    trackGiftProcessing(
      fetchCart().then(function(cart) {
        if (cart) {
          latestKnownCart = cart;
          return checkCart(cart);
        }
      })
    );
  }, 150);
});

// A coupon removed AT CHECKOUT stays on the Storefront cart (how the theme applies
// codes). /cart.js and /cart/update.js don't touch it, so it silently re-applies at
// the next checkout; only cartDiscountCodesUpdate([]) clears it.
function purgeStaleCartDiscounts(cart) {
  var token = cart && cart.token;
  if (!token) {
    return;
  }
  fetch("https://discoverpilgrim.com/api/2024-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-shopify-storefront-access-token": "960cfd6c92bca9fe2dc2b25406d6b36a"
    },
    body: JSON.stringify({
      query: "mutation($id:ID!){cartDiscountCodesUpdate(cartId:$id,discountCodes:[]){cart{discountCodes{code}} userErrors{message}}}",
      variables: { id: "gid://shopify/Cart/" + token }
    })
  }).catch(function() {});
}

$(document).ready(function() {
  trackGiftProcessing(
    fetchCart().then(function(cart) {
      latestKnownCart = cart;
      // What sessionStorage remembers from earlier this session (before we reconcile).
      var priorCodes = Array.isArray(window.PG_APPLIED_COUPON_CODES)
        ? window.PG_APPLIED_COUPON_CODES.slice()
        : [];
      // A code an app temporarily suppressed is still listed in discount_codes
      // (applicable:false), so legit/suppressed coupons survive; only genuinely
      // removed codes (absent from discount_codes) count as "gone".
      var liveCodes = (cart && Array.isArray(cart.discount_codes))
        ? cart.discount_codes.map(function(dc) { return String(dc.code || "").trim().toUpperCase(); }).filter(Boolean)
        : [];
      // A coupon applied earlier but no longer on the cart was removed at checkout —
      // purge the lingering Storefront-cart discount so it can't re-apply next checkout.
      if (priorCodes.length > 0 && liveCodes.length === 0) {
        purgeStaleCartDiscounts(cart);
      }
      // Reconcile the persisted cache with the real cart so a removed code can't
      // linger in sessionStorage and re-add the gift.
      _persistCouponCodes(liveCodes);
      return checkCart(cart);
    })
  );
});
